
import React from 'react';
import { Button, Typography, Container, Paper } from '@material-ui/core';
import { Link } from '@reach/router';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
    textAlign: 'center',
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: 60,
    color: theme.palette.success.main,
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

const MercadopagoSuccess = ({ orderId }) => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="sm" className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <CheckCircleOutlineIcon className={classes.icon} />
        <Typography variant="h4" gutterBottom>
          ¡Pago exitoso!
        </Typography>
        <Typography variant="subtitle1">
          Tu pago ha sido procesado correctamente.
        </Typography>
        <Button
          component={Link}
          to={`/order/${orderId}`}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          Ver mi pedido
        </Button>
      </Paper>
    </Container>
  );
};

export default MercadopagoSuccess;
